import StudentAttendancePage from './StudentAttendancePage';
const TeacherStudentAttendance = () => <StudentAttendancePage isAdmin={false} />;
export default TeacherStudentAttendance;